import { render, staticRenderFns } from "./PointTierAlertDialog.vue?vue&type=template&id=3af31a91"
import script from "./PointTierAlertDialog.vue?vue&type=script&lang=js"
export * from "./PointTierAlertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports